import { listaSexo } from "../../../../app/constants/constants-selectores";
import type { UsuarioFormCamposProps } from "./UsuarioFormCampos.types";

// Datos personales: documento, nombres, contacto, foto de perfil y correo personal.
export const UsuarioFormDatosPersonales = ({
    register,
    errors,
    watch,
    listaTipoDocumento,
    cambiarTipoDocumento,
    handleInputChange,
    maxLengthInput,
}: UsuarioFormCamposProps) => {
    return (
        <>
            <div className="col-12 col-lg-6">
                <div className="d-flex align-items-center">
                    <label className="col-4 text-start px-2">Documento</label>
                    <select {...register("tipo_ide", {
                        required: {
                            value: true,
                        },
                        onChange: (e) => { cambiarTipoDocumento(e.target.value) }
                    })}
                        className="form-select form-select-sm"
                        value={watch("tipo_ide")}
                    >
                        {
                            listaTipoDocumento?.length > 0 && listaTipoDocumento.map(d => (
                                <option key={d?.id} value={d?.id}>{d?.tipo}</option>
                            ))
                        }
                    </select>
                </div>
                {errors.tipo_ide && errors.tipo_ide.type === "required" && <p role="alert" className="error px-2 mb-0">Ingrese tipo de documento</p>}
            </div>

            <div className="col-12 col-lg-6">
                <div className="d-flex align-items-center">

                    <label className="col-4 text-start px-2">Número</label>
                    <input
                        {...register("num_ide", {
                            required: {
                                value: true,
                                message: "Ingrese número"
                            },
                            // INCIDENCIA Validaciones (2026-08-17): primero el mensaje EXACTO ante
                            // simbolos/espacios ("solo números y letras"), luego la longitud por tipo.
                            validate: (v: any) => {
                                const val = (v ?? "").toString().trim();
                                if (!/^[a-zA-Z0-9]+$/.test(val)) return "El número de documento deberá tener solo números y letras.";
                                if (watch("tipo_ide") === "D") return /^\d{8}$/.test(val) || "El DNI debe tener 8 dígitos.";
                                return /^[a-zA-Z0-9]{9,12}$/.test(val) || "El número de documento debe tener entre 9 y 12 caracteres.";
                            }
                        })}
                        type="text"

                        className="form-control form-control-sm"
                        autoComplete="off"
                        maxLength={maxLengthInput}
                        onInput={handleInputChange}
                    />
                </div>
                {errors.num_ide && <p role="alert" className="error px-2 mb-0">{errors.num_ide.message}</p>}
            </div>
            <div className="col-12 col-lg-12">
                <div className="d-flex align-items-center">

                    <label className="col-4 col-lg-2 text-start px-2">Nombres</label>
                    <input
                        {...register("nombre", {
                            required: {
                                value: true,
                            }
                        })}
                        type={"text"}
                        className="form-control form-control-sm"
                        autoComplete="off"
                    />
                </div>
                {errors.nombre && errors.nombre.type === "required" && <p role="alert" className="error px-2 mb-0">Ingrese nombres</p>}

            </div>
            <div className="col-12 col-lg-6">
                <div className="d-flex align-items-center">
                    <label className="col-4 text-start px-2">Ap. Paterno</label>
                    <input
                        {...register("ape_pat", {
                            required: {
                                value: true,
                            }
                        })}
                        type="text"
                        className="form-control form-control-sm"
                        autoComplete="off"
                    />
                </div>
                {errors.ape_pat && errors.ape_pat.type === "required" && <p role="alert" className="error px-2 mb-0">Ingrese apellido paterno</p>}
            </div>
            <div className="col-12 col-lg-6">
                <div className="d-flex align-items-center">

                    <label className="col-4 text-start px-2">Ap. Materno</label>
                    <input
                        {...register("ape_mat")}
                        type="text"
                        className="form-control form-control-sm"
                        autoComplete="off"
                    />
                </div>
            </div>

            <div className="col-12 col-lg-6">
                <div className="d-flex align-items-center">
                    <label className="col-4 text-start px-2">Teléfono</label>
                    <input
                        {...register("telefono")}
                        type="text"
                        className="form-control form-control-sm"
                        autoComplete="off"
                    />
                </div>
            </div>

            <div className="col-12 col-lg-6">
                <div className="d-flex align-items-center">
                    <label className="col-4 text-start px-2">Celular</label>
                    <input
                        {...register("celular")}
                        type="text"
                        className="form-control form-control-sm"
                        autoComplete="off"
                    />
                </div>
            </div>

            <div className="col-12 col-lg-6">
                <div className="d-flex align-items-center">
                    <label className="col-4 text-start px-2">Sexo</label>
                    <select {...register("sexo")} className="form-select form-select-sm" >
                        {
                            listaSexo?.length > 0 && listaSexo.map(s => (
                                <option key={s?.id} value={s?.id}>{s?.tipo}</option>
                            ))
                        }
                    </select>
                </div>
            </div>
            <div className="col-12 col-lg-6">
                <div className="d-flex align-items-center">
                    <label className="col-4 text-start px-2">Fecha de nacimiento</label>
                    <input
                        {...register("fnacimiento")}
                        type="date"
                        className="form-control form-control-sm"
                        autoComplete="off"
                        style={{ textTransform: "none" }}

                    />
                </div>
            </div>
            <div className="col-12 col-lg-6">
                <div className="d-flex align-items-center">
                    <label className="col-4 text-start px-2">Direccion</label>
                    <input
                        {...register("direccion")}
                        type="text"
                        className="form-control form-control-sm"
                        autoComplete="off"
                    />
                </div>
            </div>
            <div className="col-12 col-lg-6">
                <div className="d-flex align-items-center">
                    <label className="col-4 text-start px-2">Ubigeo</label>
                    <input
                        {...register("ubigeo")}
                        type="text"
                        className="form-control form-control-sm"
                        autoComplete="off"
                    />
                </div>
            </div>
            <div className="col-12 col-lg-6">
                <div className="d-flex align-items-center">
                    <label className="col-4 text-start px-2">Foto Perfil</label>
                    <input
                        {...register("Imagen", {
                            validate: (value) => {
                                // Verificar si se seleccionó un archivo
                                if (!value[0]) return true;
                                // Verificar si el archivo es una imagen
                                //return value[0].type.startsWith("image/");
                            },
                        })}
                        type="file"
                        className="form-control form-control-sm"
                        autoComplete="off"
                    />
                </div>
            </div>
            <div className="col-12 col-lg-6">
                <div className="d-flex align-items-center">
                    <label className="col-4 text-start px-2">Correo Per</label>
                    <input
                        {...register("email", {
                            // INCIDENCIA Validaciones (2026-08-17): correo opcional; si viene, formato
                            // valido y sin espacios (mismo criterio que el back).
                            validate: (v: any) => {
                                const val = (v ?? "").toString().trim();
                                if (!val) return true;
                                return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val) || "Correo personal no válido (ejemplo: usuario@dominio.com)";
                            }
                        })}
                        type="text"
                        className="form-control form-control-sm"
                        autoComplete="off"
                        style={{ textTransform: "none" }}
                    />
                </div>
                {errors.email && <p role="alert" className="error px-2 mb-0">{errors.email.message}</p>}
            </div>
        </>
    )
}
